import { enviroment } from "../../../../enviroment";

// The size a NEW cart row starts with. Flag cartSizeBlankDefaultEnabled on
// (Nichlas 7/10: "not M - blank as a start"): "" so the field shows its
// placeholder and a bag/cap row never carries a size nobody chose. Off: the
// historical "M". Rows already stored in the cart are never touched - this
// is only read where a row is CREATED.
export const LEGACY_DEFAULT_ROW_SIZE = "M";

export function defaultRowSize(): string {
  return enviroment.cartSizeBlankDefaultEnabled ? "" : LEGACY_DEFAULT_ROW_SIZE;
}
